module.exports = __webpack_public_path__ + "static/4bricks-35c9a69b05fab3226b3638503e3c4c8b.png";